import styles from "./OneWaySlider.module.scss";
import React, {useContext, useEffect, useRef, useState} from "react";
import appContext from "../../../context/appContext";

const OneWaySlider = React.memo((props) => {

  const { min } = props;
  const { max } = props;
  const { title } = props;
  const { currentValue } = props;
  const { handleUserSelected } = props || null;
  const ref = useRef();
  const [height, setHeight] = useState(30);
  const [percentage, setPercentage] = useState(0);
  const [point, setPoint] = useState((350 - 30) / (max - min));
  const [activePoint, setActivePoint] = useState(min);
  const [callFunction, setCallFunction] = useState(false);
  const [heightStyle, setHeightStyle] = useState({});
  const [handlerHeightStyle, setHandlerHeightStyle] = useState({});
  const [activeNode, setActiveNode] = useState(null);
  const [isDragging, setIsDragging] = useState(false);

  const [currentDivPositions, setCurrentDivPositions] = useState({
    top: 0,
    bottom: 0,
    heightOfSlider: 0,
  })

  useEffect(() => {
    setActiveNode(props.activeNode)
  }, [props.activeNode])

  const handleSliderMove = (e) => {
    setIsDragging(true);
    const clientY = e.clientY;

    if(((currentDivPositions.top + currentDivPositions.heightOfSlider) - (clientY + 30)) >= 0
      && ((currentDivPositions.top + currentDivPositions.heightOfSlider) - (clientY)) <= currentDivPositions.heightOfSlider ) {
      setHeight((currentDivPositions.top + currentDivPositions.heightOfSlider) - (clientY + 30) + 30);
      setHeightStyle({height: ((currentDivPositions.top + currentDivPositions.heightOfSlider) - (clientY + 30) + 30)});
      setHandlerHeightStyle({bottom: ((currentDivPositions.top + currentDivPositions.heightOfSlider) - (clientY + 30) + 30) - 25});
      setActivePoint((currentDivPositions.top + currentDivPositions.heightOfSlider) - (clientY + 30));
    }
  }

  useEffect(() => {
    if (props?.type === "edges" && (activeNode > min)) {
      props.onEdgesTouched()
    }
  }, [activeNode])

  const handleMouseUp = (e) => {
    setIsDragging(false);
    setCallFunction(true);
    window.removeEventListener('mousemove', handleSliderMove);
    window.removeEventListener('mouseup', handleMouseUp);
  }

  const handleMouseDown = (e) => {
    context.handleFiltersSubmitClicked(false);
    window.addEventListener('mousemove', handleSliderMove);
    window.addEventListener('mouseup', handleMouseUp);
  }

  useEffect(() => {
    if (max - min > 0) {
      setPoint((350 - 30) / (max - min));
    }
  }, [props.min, props.max]);

  useEffect(() => {
    if (isDragging && props.max >= (Math.floor(activePoint / point)) + min) {
      props.setActive((Math.floor(activePoint / point)) + min);
    }
  }, [activePoint, props.min]);

  useEffect(() => {
    setPercentage(props.percentage);
  }, [props.percentage]);

  useEffect(() => {
    if (callFunction) {
      if (handleUserSelected) {
        handleUserSelected(activeNode);
      }
      props.callFunction((Math.floor(activePoint / point)) + min);
      setCallFunction(false);
    }
  }, [callFunction])

  const context = useContext(appContext);

  useEffect(() => {
    if (!isDragging && !callFunction && !context.handleFiltersSubmitClicked()) {
      const positions = ref.current.getBoundingClientRect();
      let height = ((positions.height / ((max - min))) * (activeNode - min) + 25);
      if (height <= 30) {
        height = 30;
      } else if (height > 350) {
        height = 350;
      }
      setHeight(height);
      setHeightStyle({height: height});
      setHandlerHeightStyle({bottom: height - 25});
    }
  }, [callFunction, isDragging, activeNode, props.percentage])

  useEffect(() => {
    setTimeout(() => {
      if (context.handleFiltersSubmitClicked()) {
        setHeight(30);
        setHeightStyle({height: 30});
        setHandlerHeightStyle({bottom: 5});
        setActiveNode(min);
      }
    }, 0)

  }, [context.handleFiltersSubmitClicked()])

  useEffect(() => {
    const positions = ref.current.getBoundingClientRect();
    setCurrentDivPositions({
      top: positions.top,
      bottom: positions.bottom,
      heightOfSlider: positions.height,
    });
    let height = ((positions.height / ((max - min))) * (currentValue - min) + 25);
    if (height <= 30) {
      height = 30;
    } else if (height > 350) {
      height = 350;
      setActiveNode(min);
    } else {
      setActiveNode(min);
    }
    setHeight(height);
    setHeightStyle({height: isNaN(height) ? 30 : height});
    setHandlerHeightStyle({bottom: height - 25});
    setActivePoint(currentValue);
    setActiveNode(currentValue);

    return function cleanupListener() {
      document.removeEventListener('mousemove', handleSliderMove, false)
      document.removeEventListener('mouseup', handleMouseUp, false)
    }
  }, []);

  useEffect(() => {
    if (context.handleApiStatusProcessExplorer() === "success") {
      setActiveNode(props.currentValue)
    }
  }, [context.handleApiStatusProcessExplorer()])

  return (
    <div className={styles.OneWaySlider}>
      <div ref={ref} className={styles.sliderContainer}>
        <div className={styles.percentage}>{!isNaN(percentage) && percentage > 0 ? <span>{percentage}</span> : <span>0</span>}%</div>
        <div className={styles.height} style={heightStyle}></div>
        <div style={(height > 115) ? {color: "#FFFFFF"} : null} className={styles.title}>{title}</div>
        <div draggable={"false"} style={handlerHeightStyle} onMouseDown={handleMouseDown} className={styles.handler}>
          <span>{activeNode}</span>
        </div>
      </div>
      <div className={'mt-2 cursor-pointer'} onClick={() => {
        if (max >= activeNode + 1) {
          setActiveNode(activeNode + 1)
          setActivePoint(activeNode + 1)
          props.setActive(activeNode + 1)
          setCallFunction(true)
        }
      }}>
        <svg width="30" height="30" viewBox="0 0 30 30" fill="none" xmlns="http://www.w3.org/2000/svg">
          <circle cx="15" cy="15" r="14.5" fill="white" stroke="#C2C7ED"/>
          <path fill-rule="evenodd" clip-rule="evenodd" d="M14.9998 11.0417C15.345 11.0417 15.6248 11.3215 15.6248 11.6667V14.375H18.3332C18.6783 14.375 18.9582 14.6548 18.9582 15C18.9582 15.3452 18.6783 15.625 18.3332 15.625H15.6248V18.3334C15.6248 18.6785 15.345 18.9584 14.9998 18.9584C14.6547 18.9584 14.3748 18.6785 14.3748 18.3334V15.625H11.6665C11.3213 15.625 11.0415 15.3452 11.0415 15C11.0415 14.6548 11.3213 14.375 11.6665 14.375H14.3748V11.6667C14.3748 11.3215 14.6547 11.0417 14.9998 11.0417Z" fill="#363853"/>
        </svg>
      </div>
      <div className={'mt-1 cursor-pointer'} onClick={() => {
        if (min <= activeNode - 1) {
          setActiveNode(activeNode - 1)
          setActivePoint(activeNode - 1)
          props.setActive(activeNode - 1)
          setCallFunction(true)
        }
      }}>
        <svg width="30" height="30" viewBox="0 0 30 30" fill="none" xmlns="http://www.w3.org/2000/svg">
          <circle cx="15" cy="15" r="14.5" fill="white" stroke="#C2C7ED"/>
          <path d="M11.6665 15H18.3332" stroke="#363853" stroke-width="1.5" stroke-linecap="round"/>
        </svg>
      </div>
    </div>
  )
});

export default OneWaySlider;
